import { NgbDateStruct, NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';
import { isEmpty as _isEmpty, get } from 'lodash-es';
import { isDate, isNumber, isString } from './type-util';

/**
 * Checks if a value is empty. Behaves like lodash's `isEmpty` with 3 exceptions:
 *
 * * Strings consisting of only spaces are considered empty.
 * * Non-null and non-undefined numbers are not considered empty.
 * * Date objects are never considered empty.
 */
export function isEmpty(x?: unknown): boolean {
  if (isString(x)) {
    return x.trim().length === 0;
  } else if (isNumber(x)) {
    return x == null;
  } else if (isDate(x)) {
    return false;
  }

  return _isEmpty(x);
}

/**
 * Opposite of `{@link isEmpty}`
 */
export function isNotEmpty(x?: unknown): boolean {
  return !isEmpty(x);
}

/**
 * Checks if an object property is empty. Uses lodash's `get` internally
 * for traversing the object.
 */
export function isPropertyEmpty(x: unknown, propertyPath: string): boolean {
  if (!isEmpty(propertyPath)) {
    return isEmpty(get(x, propertyPath));
  }

  return isEmpty(x);
}

export function isNgbDateStructEmpty(dateStruct: NgbDateStruct) {
  return dateStruct == null || dateStruct.year == null || dateStruct.month == null || dateStruct.day == null;
}

export function isNgbTimeStructEmpty(timeStruct: NgbTimeStruct) {
  return timeStruct == null || timeStruct.hour == null || timeStruct.minute == null || timeStruct.second == null;
}
